import { create } from 'apisauce';
import queryString from 'query-string';
import axiosInstance from './axiosInstance';
import formatDate from '../services/formatDate';
import dayjs from 'dayjs';

let api = null;
export const token = () => localStorage.token;

const imgbaseURL = process.env.IMGBASEURL;
const googleApiKey = process.env.GOOGLEKEY;
const redirectURL = 'https://connectrn.com/'; // Production URL(NEW)
// let redirectURL = 'https://admin.connectrn.com/connectrn/' //PRODUCTION
// let redirectURL = 'http://test.connectrn.com/connectrn/' //UAT
// let redirectURL = 'http://crncoderefactor.venturit.net/connectrn' //TESTING

const init = (baseURL) => {
	api = create({ baseURL, headers: { Accept: 'application/json' } });
};

const setHeader = () => {
	const bearerToken = localStorage.getItem('token');
	if (bearerToken !== undefined) {
		api.setHeader('Authorization', `Bearer ${bearerToken}`);
		return true;
	}
	return false;
};

const login = (email, pass) => api.post('/user/login', { email, password: pass });

const forgotPassword = (email) => api.post('/user/forgotpassword', { email });

const newUpdatePassword = (userID, newPass, oldPass = '', hashCode = '', mimicToken = '') => {
	if (mimicToken !== '') api.setHeader('Authorization', `Bearer ${mimicToken}`);
	return api.put('/user/updatepassword', {
		hash_code: hashCode,
		new_password: newPass,
		old_password: oldPass,
		user_id: userID
	});
};

const setPicture = (pic) => {
	if (setHeader()) {
		api.setHeader('Content-Type', 'multipart/form-data');
		const data = new FormData();
		data.append('file', pic);

		return api.post('/user/image', data);
	}
	return Promise.resolve({});
};

const setPush = (enable) => {
	if (setHeader()) {
		return api.put('/user/push', { enable });
	}
	return Promise.resolve({});
};

const shiftsAvailable = () => {
	if (setHeader()) {
		return api.get('/shifts/available');
	}
	return Promise.resolve({});
};

const applyShift = (id) => {
	if (setHeader()) {
		return api.post(`/shift/${id}/apply`);
	}
	return Promise.resolve({});
};

const calloutShift = (id, reason) => {
	if (setHeader()) {
		return api.post(`/shift/${id}/callout`, { reason });
	}
	return Promise.resolve({});
};

const calloutShiftByAdmin = (id, reason, nurse_id) => {
	if (setHeader()) {
		return api.post(`/shift/${id}/admincallout`, { nurse_id, reason });
	}
	return Promise.resolve({});
};

const withdrawShift = (id, reason) => {
	if (setHeader()) {
		return api.post(`/shift/${id}/withdraw`, { reason });
	}
	return Promise.resolve({});
};

const notices = () => {
	if (setHeader()) {
		return api.get('/user/notices');
	}
	return Promise.resolve({});
};

const noticeCount = () => {
	if (setHeader()) {
		return api.get('/user/notice/count');
	}
	return Promise.resolve({});
};
const organization = () => {
	if (setHeader()) {
		return api.get('/organizations');
	}
	return Promise.resolve({});
};
const organizationById = (id) => {
	if (setHeader()) {
		return api.get(`/organization/${id}`);
	}
	return Promise.resolve({});
};
const deleteNotices = (id) => {
	if (setHeader()) {
		return api.delete(`/user/notice/${id}`);
	}
	return Promise.resolve({});
};
const supervisors = (id, locid) => {
	if (setHeader()) {
		return api.get(`/organization/${id}/${locid}/supervisors`);
	}
	return Promise.resolve({});
};
const userinfo = () => {
	if (setHeader()) {
		return api.get('/user/info');
	}
	return Promise.resolve({});
};

const nurseSkills = (nurseID) => {
	if (setHeader()) {
		return api.get(`/users/${nurseID}/skills`);
	}
	return Promise.resolve({});
};

const nurseDashboard = (
	page_no,
	status,
	organization,
	location,
	department,
	supervisor,
	from_date,
	to_date,
	zip_code,
	sort,
	sortorder,
	distance,
	approvalStatus,
	shiftID,
	shift_accepeted_status,
	days,
	locationids,
	times,
	search,
	_excludeWaitlist,
	_onlyRecommended
) => {
	if (setHeader()) {
		return api.get('/user/nursedashboard', {
			approval: approvalStatus,
			days,
			department,
			distance,
			exclude_waitlist: _excludeWaitlist,
			from_date,
			is_recommended: _onlyRecommended,
			location,
			locationids,
			organization,
			page_no,
			search,
			shift_accepted_status: shift_accepeted_status,
			shift_id: shiftID,
			sort,
			sortorder,
			status,
			supervisor,
			times,
			to_date,
			zip_code
		});
	}
	return Promise.resolve({});
};

const updateUserContact = (
	firstName,
	lastName,
	address,
	city,
	state,
	zipcode,
	primaryPhoneNumber,
	alternatePhoneNumber,
	address2
) => {
	if (setHeader()) {
		return api.put('/onboarding/demographics', {
			additional_address: address2,
			address,
			alt_phone: alternatePhoneNumber,
			city,
			first_name: firstName,
			last_name: lastName,
			phone: primaryPhoneNumber,
			state,
			zip: zipcode
		});
	}
	return Promise.resolve({});
};

const userContact = () => {
	if (setHeader()) {
		return api.get('/user/info');
	}
	return Promise.resolve({});
};

const updateUserJobHistory = (fileID, histories) => {
	if (setHeader()) {
		return api.post('/onboarding/jobhistory', {
			job_history: histories,
			resume_file_id: fileID
		});
	}
	return Promise.resolve({});
};

const userJobHistory = () => {
	if (setHeader()) {
		return api.get('onboarding/jobhistory');
	}
	return Promise.resolve({});
};

const commonFileUpload = (file) => {
	if (setHeader()) {
		api.setHeader('Content-Type', 'multipart/form-data');
		const data = new FormData();
		data.append('file', file);
		return api.post('/user/upload', data);
	}
	return Promise.resolve({});
};

const getOnboardingStatus = () => {
	if (setHeader()) {
		return api.get('/user/onboarding');
	}
	return Promise.resolve({});
};

const getIdentificationInfo = () => {
	if (setHeader()) {
		return api.get('/onboarding/license');
	}
	return Promise.resolve({});
};

const updateIdentificationInfo = (
	identification_front_file_id,
	identification_back_file_id,
	identification_state,
	identification_exp_date,
	identification_license_num
) => {
	if (setHeader()) {
		return api.put('/onboarding/license', {
			license_expiry: identification_exp_date,
			license_id: identification_license_num,
			license_photo: identification_front_file_id,
			license_photo_back: identification_back_file_id,
			license_state: identification_state
		});
	}
	return Promise.resolve({});
};

const updateRegistrationInfo = (registration_file_id, registration_license_num, registration_exp_date) => {
	if (setHeader()) {
		return api.post('/onboarding/regulatory', {
			document: registration_file_id,
			document_expiration: registration_exp_date,
			document_id: registration_license_num,
			regulatory_type_id: 1
		});
	}
	return Promise.resolve({});
};

const getRegulatoryInfo = (typeID) => {
	if (setHeader()) {
		return api.get(`/onboarding/regulatory/${typeID}`);
	}
	return Promise.resolve({});
};

const updateCprCertificateInfo = (cpr_certificate_file_id, cpr_certificate_exp_date) => {
	if (setHeader()) {
		return api.post('/onboarding/regulatory', {
			document: cpr_certificate_file_id,
			document_expiration: cpr_certificate_exp_date,
			regulatory_type_id: 5
		});
	}
	return Promise.resolve({});
};

const updateAclsCertificateInfo = (acls_certificate_file_id, acls_certificate_exp_date) => {
	if (setHeader()) {
		return api.post('/onboarding/regulatory', {
			document: acls_certificate_file_id,
			document_expiration: acls_certificate_exp_date,
			regulatory_type_id: 4
		});
	}
	return Promise.resolve({});
};

const updateUserRole = (role_id) => {
	if (setHeader()) {
		return api.put('/onboarding/role', { role_id });
	}
	return Promise.resolve({});
};

const updateUserSpeciality = (speciality_id) => {
	if (setHeader()) {
		return api.put('/onboarding/specialty', { specialty_id: speciality_id });
	}
	return Promise.resolve({});
};

const updateUserYearsOfExperience = (years_of_experience) => {
	if (setHeader()) {
		return api.put('/onboarding/yearsofexperience', { years_of_experience });
	}
	return Promise.resolve({});
};

const getShiftDetail = (shiftid) => {
	if (setHeader()) {
		return api.get(`/shift/${shiftid}`);
	}
	return Promise.resolve({});
};
const setProfilePic = (id) => `${imgbaseURL}/api/v3/user/profilepic/${id}`;

const userSkill = () => {
	if (setHeader()) {
		return api.get('/onboarding/skills');
	}
	return Promise.resolve({});
};

const updateUserSkill = (skills) => {
	if (setHeader()) {
		return api.post('/onboarding/skills', skills);
	}
	return Promise.resolve({});
};

const getAccessLevels = () => {
	if (setHeader()) {
		return api.get(`/access-levels`);
	}
	return Promise.resolve({});
};

const saveAccessLevel = (userId, newAccessLevelId) => {
	if (setHeader()) {
		return api.post(`/users/${userId}/access-level`, { access_level_id: parseInt(newAccessLevelId) });
	}
	return Promise.resolve({});
};

//Enterprise setting
const enterpriseSettings = () => {
	if (setHeader()) {
		return api.get('/enterprise-settings');
	}
	return Promise.resolve({});
};

//Location setting
const getLocationSettings = (locationId) => {
	if (setHeader()) {
		return api.get(`/locations/${locationId}/settings`);
	}
	return Promise.resolve({});
};

const updateLocationSettings = (locationId, settingId, value) => {
	if (setHeader()) {
		return api.put(`/locations/${locationId}/settings/${settingId}`, { value: value });
	}
	return Promise.resolve({});
};

const deleteLocationsSettings = (locationId, settingId) => {
	if (setHeader()) {
		return api.delete(`/locations/${locationId}/settings/${settingId}`);
	}
	return Promise.resolve({});
};

//Organization setting

const getOrgSettings = (orgId) => {
	if (setHeader()) {
		return api.get(`/organizations/${orgId}/settings`);
	}
	return Promise.resolve({});
};

const updateOrgSettings = (orgId, settingId, value) => {
	if (setHeader()) {
		return api.put(`/organizations/${orgId}/settings/${settingId}`, { value: value });
	}
	return Promise.resolve({});
};

const deleteOrgSettings = (orgId, settingId) => {
	if (setHeader()) {
		return api.delete(`/organizations/${orgId}/settings/${settingId}`);
	}
	return Promise.resolve({});
};

//Nurse skills
const getSkills = (nurseId) => {
	if (setHeader()) {
		return api.get(`/users/${nurseId}/skills`);
	}
	return Promise.resolve({});
};

const saveSkills = (nurseId, skill) => {
	if (setHeader()) {
		return api.post(`/users/${nurseId}/skills`, {
			is_approved: skill?.isApproved,
			skill_id: skill?.id
		});
	}
	return Promise.resolve({});
};

const updateSkills = (nurseId, skill) => {
	if (setHeader()) {
		return api.put(`/users/${nurseId}/skills/${skill.id}`, {
			is_approved: skill?.attestations?.length > 0
		});
	}
	return Promise.resolve({});
};

const deleteSkills = (nurseId, skillId) => {
	if (setHeader()) {
		return api.delete(`/users/${nurseId}/skills/${skillId}`);
	}
	return Promise.resolve({});
};

const getGeoLocation = (address) =>
	create({ baseURL: 'https://maps.googleapis.com/maps/api/geocode' }).get(
		`/json?address=${address}&key=${googleApiKey}`
	);

const resetOnboarding = () => {
	if (setHeader()) {
		return api.post('/user/restartonboarding');
	}
	return Promise.resolve({});
};

const roleOptions = () => {
	if (setHeader()) {
		return api.get('/roles');
	}
	return Promise.resolve({});
};

const getRateIncreaseOptions = (location_id) => {
	if (setHeader()) {
		return api.get('/rateincreaseoptions', { location_id });
	}
	return Promise.resolve({});
};

const getLocShiftTimes = (loc_id, org_id) => {
	if (setHeader()) {
		return api.get('/org/locationshifttimes', {
			loc_id,
			org_id
		});
	}
	return Promise.resolve({});
};

const updateRateIncrease = (location_id, rate) => {
	if (setHeader()) {
		return api.post('/admin/organizations/locations/rateincrease', {
			location_id,
			rate
		});
	}
	return Promise.resolve({});
};
const yearOfExpOptions = () => {
	if (setHeader()) {
		return api.get('/yearsofexp');
	}
	return Promise.resolve({});
};

const supervisorDashboard = (
	page_no,
	organization_id,
	status,
	role,
	location,
	department,
	supervisor,
	from_date,
	to_date,
	sort,
	sortorder
) => {
	if (setHeader()) {
		return api.get('/user/supervisordashboard', {
			department,
			from_date,
			location,
			organization_id,
			page_no,
			role,
			sort,
			sortorder,
			status,
			supervisor,
			to_date
		});
	}
	return Promise.resolve({});
};

const supervisorDashboardV2 = (
	page_no,
	organization_id,
	status,
	role,
	location,
	department,
	supervisor,
	from_date,
	to_date,
	sort,
	sortorder
) => {
	if (setHeader()) {
		return api.get('/user/supervisordashboardv2', {
			department,
			from_date,
			location,
			organization_id,
			page_no,
			role,
			sort,
			sortorder,
			status,
			supervisor,
			to_date
		});
	}
	return Promise.resolve({});
};

const getAcceptedShiftApplicant = (id) => {
	if (setHeader()) {
		return api.get(`/user/getacceptedshiftapplicant/${id}`);
	}
	return Promise.resolve({});
};

const getOrgShiftTimes = (id) => {
	if (setHeader()) {
		return api.get(`/org/getorgshifttimes?org_id=${id}`);
	}
	return Promise.resolve({});
};

const getHolidayDates = (locid, year) => {
	if (setHeader()) {
		return api.get('/holidays', {
			locid,
			year
		});
	}
	return Promise.resolve({});
};

const getClinicianPools = () => {
	if (setHeader()) {
		return api.get('/clinicianpools');
	}
	return Promise.resolve({});
};

const getPublicShiftDetail = (token, shiftid) => {
	api.setHeader('Authorization', `Bearer ${token}`);
	return api.get(`/supervisor/shift/${shiftid}`);
};

const getSupervisorShiftDetail = (shiftid) => {
	if (setHeader()) {
		return api.get(`/supervisor/shift/${shiftid}`);
	}
	return Promise.resolve({});
};
const supervisorCancelShift = (shift_id, shift_cancellation_notes, shift_cancellation_reason) => {
	if (setHeader()) {
		return api.put('/user/cancelshift', {
			shift_cancellation_notes: shift_cancellation_notes.trim(),
			shift_cancellation_reason,
			shift_id
		});
	}
	return Promise.resolve({});
};

const supervisorReportNoShowApplicant = (shiftId, applicantId) => {
	if (setHeader()) {
		return api.post('supervisor/report-noshow', {
			applicant_id: applicantId,
			shift_id: shiftId
		});
	}
	return Promise.resolve({});
};

const getPublicAppliedShiftApplicant = (token, id) => {
	api.setHeader('Authorization', `Bearer ${token}`);
	return api.get(`/user/getshiftapplicant/${id}`);
};

const getAppliedShiftApplicant = (id) => {
	if (setHeader()) {
		return api.get(`/user/getshiftapplicant/${id}`);
	}
	return Promise.resolve({});
};

const acceptPublicShiftApplicant = (token, user_id, shift_id) => {
	api.setHeader('Authorization', `Bearer ${token}`);
	return api.post('/user/acceptshiftapplicant', {
		shift_id,
		user_id
	});
};

const acceptShiftApplicant = (user_id, shift_id, is_overtime_accepted) => {
	if (setHeader()) {
		return api.post('/user/acceptshiftapplicant', {
			is_overtime_accepted,
			shift_id,
			user_id
		});
	}
	return Promise.resolve({});
};

const rejectShiftApplicant = (user_id, shift_id) => {
	if (setHeader()) {
		return api.delete('/user/rejectshiftapplicant', {
			shift_id,
			user_id
		});
	}
	return Promise.resolve({});
};

const createNewShift = (shiftObj = {}) => {
	if (setHeader()) {
		return api.post('/shifts/create', shiftObj);
	}
	return Promise.resolve({});
};

const createShifts = (shiftObj = {}) => {
	if (setHeader()) {
		return api.post('/shifts/create-multiple', shiftObj);
	}
	return Promise.resolve({});
};

const createMultiTimeShifts = (shiftObj = {}) => {
	if (setHeader()) {
		return api.post('/shifts/create-multiple-v2', shiftObj);
	}
	return Promise.resolve({});
};

const sendMessages = (user_id, message, sent_by, orgID) => {
	if (setHeader()) {
		return api.post('/user/sendmessage', {
			message,
			org_id: orgID,
			sent_by,
			user_id
		});
	}
	return Promise.resolve({});
};
const getOrganizationMessages = (orgID, nurseID) => {
	if (setHeader()) {
		return api.get('/user/organization-messages', {
			nurse_id: nurseID,
			org_id: orgID
		});
	}
	return Promise.resolve({});
};

const getRegistrationRegulatory = (user_id) => {
	if (setHeader()) {
		return api.get('/user/regulatory/1', {
			user_id
		});
	}
	return Promise.resolve({});
};

const getCPRRegulatory = (user_id) => {
	if (setHeader()) {
		return api.get('/user/regulatory/5', {
			user_id
		});
	}
	return Promise.resolve({});
};

const getACLSRegulatory = (user_id) => {
	if (setHeader()) {
		return api.get('/user/regulatory/4', {
			user_id
		});
	}
	return Promise.resolve({});
};
const getJobHistory = (user_id) => {
	if (setHeader()) {
		return api.get('/user/jobhistory', {
			user_id
		});
	}
	return Promise.resolve({});
};
const getAlert = (org_id, priority) => {
	if (setHeader()) {
		return api.get('/alert/getalert', {
			org_id,
			priority
		});
	}
	return Promise.resolve({});
};
const createAlert = (organization_id, location_id, department_id, priority, message, expiration_time) => {
	if (setHeader()) {
		return api.post('/alert/create', {
			department_id,
			expiration_time,
			location_id,
			message,
			organization_id,
			priority
		});
	}
	return Promise.resolve({});
};

const getRequirement = (search_string) => {
	if (setHeader()) {
		let path = '/requirements?search_string=';
		if (search_string !== undefined) {
			path += search_string;
		}
		return api.get(path);
	}
	return Promise.resolve({});
};

const createUserInstance = (userObj) => {
	if (setHeader()) {
		return api.post('/admin/user/create', {
			additional_address: userObj.address2,
			address: userObj.address,
			alt_phone: userObj.alternatePhoneNumber,
			city: userObj.city,
			dept_id: parseInt(userObj.dept_id),
			email: userObj.email,
			emp_type: userObj.employment,
			file_type: userObj.file_type,
			first_name: userObj.firstName,
			is_admin: userObj.type == '1' ? 'Y' : '',
			is_nurse: userObj.type == '3' ? 'Y' : '',
			is_supervisor: userObj.type == '2' ? 'Y' : '',
			last_name: userObj.lastName,
			loc_id: parseInt(userObj.loc_id),
			nurse_pool_type: userObj.nurse_pool,
			org_id: parseInt(userObj.org_id),
			password: userObj.newPassword,
			phone: userObj.primaryPhoneNumber,
			photo_location: userObj.profileImagePath,
			role_id: parseInt(userObj.role_id),
			security_code: userObj.type == '2' ? parseInt(userObj.addUserAutoGenerateCode) : null,
			state: userObj.state,
			user_notes: userObj.note,
			years_of_experience: userObj.years_of_experience_id && parseInt(userObj.years_of_experience_id),
			zip: userObj.zipcode
		});
	}
	return Promise.resolve({});
};

const addRequirement = (
	auto_approve,
	title,
	required_doc_count,
	connectrn_req,
	req_type,
	multi_ins_support,
	loc_specific_exp,
	isMandatoryRoleStateEnabled,
	fields = [],
	req_options = [],
	protect,
	mask_format,
	mandatoryRoleType,
	mandatoryStateType,
	mandatoryRoles,
	mandatoryStates,
	covid19DateExtended,
	reqDescription
) => {
	if (setHeader()) {
		return api.post('/requirements/create', {
			auto_approve,
			connectrn_req,
			covid19_date_extended: covid19DateExtended,
			fields,
			is_location_specific_auto_expiry: loc_specific_exp,
			is_mandatory_roles_states_enabled: isMandatoryRoleStateEnabled,
			mandatory_role_type: mandatoryRoleType,
			mandatory_roles: mandatoryRoles,
			mandatory_state_type: mandatoryStateType,
			mandatory_states: mandatoryStates,
			mask_format,
			multi_ins_support,
			protect,
			req_description: reqDescription,
			req_options,
			req_type,
			required_doc_count,
			title
		});
	}
	return Promise.resolve({});
};
const deleteRequirement = (id) => {
	if (setHeader()) {
		return api.delete(`/requirements/delete/${id}`);
	}
	return Promise.resolve({});
};

const editRequirement = (
	auto_approve,
	id,
	title,
	connectrn_req,
	req_type,
	multi_ins_support,
	loc_specific_exp,
	fields,
	req_options = [],
	required_doc_count,
	protect,
	mask_format,
	isMandatoryEditRoleStateEnabled,
	covid19DateExtended,
	mandatoryRoleType,
	mandatoryStateType,
	mandatoryRoles,
	mandatoryStates,
	reqDescription
) => {
	if (setHeader()) {
		return api.post('/requirements/edit', {
			auto_approve,
			connectrn_req,
			covid19_date_extended: covid19DateExtended,
			fields,
			id,
			is_location_specific_auto_expiry: loc_specific_exp,
			is_mandatory_roles_states_enabled: isMandatoryEditRoleStateEnabled,
			mandatory_role_type: mandatoryRoleType,
			mandatory_roles: mandatoryRoles,
			mandatory_state_type: mandatoryStateType,
			mandatory_states: mandatoryStates,
			mask_format,
			multi_ins_support,
			protect,
			req_description: reqDescription,
			req_options,
			req_type,
			required_doc_count,
			title
		});
	}
	return Promise.resolve({});
};
const getRequirementById = (id) => {
	if (setHeader()) {
		return api.get(`/requirement/${id}`);
	}
	return Promise.resolve({});
};

const getRequirementByIdAndOrg = (reqID, orgID) => {
	if (setHeader()) {
		return api.get(`/requirement/${reqID}/${orgID}`);
	}
	return Promise.resolve({});
};

const getRequirementByIdToSchedule = (id) => {
	if (setHeader()) {
		return api.get(`/toschedule/requirement/${id}`);
	}
	return Promise.resolve({});
};

const uploadFileOnS3 = (file, user_id = '') => {
	if (setHeader()) {
		api.setHeader('Content-Type', 'multipart/form-data');

		const data = new FormData();
		data.append('file', file);
		data.append('user_id', user_id);

		return api.post('/user/upload', data);
	}
	return Promise.resolve({});
};

const uploadFileOnS3UserProfile = (file, user_id = '') => {
	if (setHeader()) {
		api.setHeader('Content-Type', 'multipart/form-data');

		const data = new FormData();
		data.append('file', file);
		data.append('user_id', user_id);

		return api.post('/user/uploadprofilepic', data);
	}
	return Promise.resolve({});
};

const uploadResume = (file, user_id) => {
	if (setHeader()) {
		api.setHeader('Content-Type', 'multipart/form-data');

		const data = new FormData();
		data.append('file', file);
		data.append('user_id', user_id);

		return api.post('/user/uploadresume', data);
	}
	return Promise.resolve({});
};

const getAdminOrganizations = (page_no, search_string, sort, sortorder, orgStatusFilter) => {
	if (setHeader()) {
		return api.get('/admin/organizations', {
			page_no,
			search_string,
			sort,
			sortorder,
			status: orgStatusFilter > 0 ? orgStatusFilter : ''
		});
	}
	return Promise.resolve({});
};

const addUserRequirement = (requirement_id, user_id, option_id, isApproved, user_docs = [], user_fields = []) => {
	if (setHeader()) {
		return api.post(`admin/requirements/user/${user_id}/add`, {
			isApproved,
			option_id: parseInt(option_id),
			requirement_id: parseInt(requirement_id),
			user_docs,
			user_fields,
			user_id: parseInt(user_id)
		});
	}
	return Promise.resolve({});
};

const updateUserRequirement = (
	requirement_id,
	user_req_id,
	user_id,
	option_id,
	isApproved,
	user_docs = [],
	user_fields = []
) => {
	if (setHeader()) {
		return api.post(`admin/requirements/user/${user_id}/updateV2`, {
			id: parseInt(user_req_id),
			isApproved,
			option_id: parseInt(option_id),
			requirement_id: parseInt(requirement_id),
			user_docs,
			user_fields,
			user_id: parseInt(user_id)
		});
	}
	return Promise.resolve({});
};

const getUserRequirements = (user_id) => {
	if (setHeader()) {
		return api.get(`/admin/requirements/user/${user_id}`);
	}
	return Promise.resolve({});
};

const getUserRequirementsForShift = (user_id, shift_id) => {
	if (setHeader()) {
		return api.get(`/admin/shift/requirements/user/${user_id}/${shift_id}`);
	}
	return Promise.resolve({});
};

const getUserRequirementToUpdate = (user_id, req_id) => {
	if (setHeader()) {
		return api.get(`/admin/requirements/user/${user_id}/${req_id}`);
	}
	return Promise.resolve({});
};

const getDecryptedUserRequirement = (user_id, user_req_id) => {
	if (setHeader()) {
		return api.get(`/admin/requirements/decryptV2/user/${user_id}/${user_req_id}`);
	}
	return Promise.resolve({});
};

const getUserRequirementToAdd = (req_id) => {
	if (setHeader()) {
		return api.get(`/requirement/${req_id}`);
	}
	return Promise.resolve({});
};

const deleteUserRequirement = (user_req_id, user_id) => {
	if (setHeader()) {
		return api.delete(`/admin/requirement/removeV2?user_id=${user_id}&user_req_id=${user_req_id}`);
	}
	return Promise.resolve({});
};

const searchUserRequirement = (search_string) => {
	if (setHeader()) {
		let path = '/requirements/search?search_string=';
		if (search_string !== undefined) {
			path += search_string;
		}
		return api.get(path);
	}
	return Promise.resolve({});
};

const createUserJobHistory = (id, start_date, end_date, title, company, city, state, description) => {
	if (setHeader()) {
		return api.post('/admin/jobhistory/create', {
			job_city: city,
			job_company: company,
			job_description: description,
			job_end_date: end_date,
			job_start_date: start_date,
			job_state: state,
			job_title: title,
			user_id: id
		});
	}
	return Promise.resolve({});
};

const createJobHistoryByNurse = (start_date, end_date, title, company, city, state, description) => {
	if (setHeader()) {
		return api.post('/nurse/jobhistory/create', {
			job_city: city,
			job_company: company,
			job_description: description,
			job_end_date: end_date,
			job_start_date: start_date,
			job_state: state,
			job_title: title
		});
	}
	return Promise.resolve({});
};

const getUserJobHistories = (user_id) => {
	if (setHeader()) {
		return api.get(`/user/jobhistory?user_id=${user_id}`);
	}
	return Promise.resolve({});
};

const deleteUserJobHistory = (id) => {
	if (setHeader()) {
		return api.delete('/admin/jobhistory/delete', { id });
	}
	return Promise.resolve({});
};

const updateUserJobHistoryByAdmin = (id, user_id, start_date, end_date, title, company, city, state, description) => {
	if (setHeader()) {
		return api.put('/admin/jobhistory/update', {
			id,
			job_city: city,
			job_company: company,
			job_description: description,
			job_end_date: end_date,
			job_start_date: start_date,
			job_state: state,
			job_title: title,
			user_id
		});
	}
	return Promise.resolve({});
};

const updateJobHistoryByNurse = (id, start_date, end_date, title, company, city, state, description) => {
	if (setHeader()) {
		return api.put('/nurse/jobhistory/update', {
			id,
			job_city: city,
			job_company: company,
			job_description: description,
			job_end_date: end_date,
			job_start_date: start_date,
			job_state: state,
			job_title: title
		});
	}
	return Promise.resolve({});
};

const getUsersWithPaging = (user_state) => {
	if (setHeader()) {
		return api.get('/admin/users', {
			access_level_id: user_state.access_level?.id,
			account_status: user_state.account_status,
			account_type: user_state.account_type,
			department_id: user_state.dept,
			emp_type: user_state.emp_type,
			from_date: user_state.from_date !== '' ? formatDate.clientDateToYyMmDd(user_state.from_date) : '',
			location_id: user_state.loc,
			loyalty_level: user_state.loyalty_level,
			nurse_pool_type: user_state.nurse_pool_type,
			organization_id: user_state.org,
			page_no: parseInt(user_state.page_no),
			role_id: user_state.role,
			search: user_state.search_string,
			sort: user_state.sort,
			sort_order: user_state.sortOrder,
			statcash_status: user_state.statcash_status,
			state: user_state.state,
			to_date: user_state.to_date !== '' ? formatDate.clientDateToYyMmDd(user_state.to_date) : '',
			years_of_experience: user_state.years_of_experience_id
		});
	}
	return Promise.resolve({});
};

const deleteUserRecord = (id) => {
	if (setHeader()) {
		return api.delete('/admin/user/delete', { user_id: id });
	}
	return Promise.resolve({});
};
const createOrganization = (
	organization_id,
	is_test_org,
	title,
	city,
	state,
	storage_location,
	timezone_id,
	shift_cutoff_hours,
	emr,
	organizationStatus,
	shift_cancellation_billable_hours,
	org_bonus_amount,
	default_PRN_days
) => {
	if (setHeader()) {
		return api.post('/admin/organizations/addupdate', {
			city,
			default_PRN_days,
			emr,
			is_test_org,
			org_bonus_amount,
			organization_id,
			organization_status: organizationStatus,
			shift_cancellation_billable_hours,
			shift_cutoff_hours,
			state,
			storage_location,
			timezone_id,
			title
		});
	}
	return Promise.resolve({});
};
const createOrganizationAcquisition = (organization_id, organization_name, transition_date) => {
	if (setHeader()) {
		return api.post(`/admin/organization/${organization_id}/acquisition`, {
			organization_name,
			transition_date
		});
	}
	return Promise.resolve({});
};
const getOrgAcquisition = (organization_id) => {
	if (setHeader()) {
		return api.get(`/admin/organization/${organization_id}/acquisition`);
	}
	return Promise.resolve({});
};
const CSType = () => {
	if (setHeader()) {
		return api.get('/admin/organizations/types');
	}
	return Promise.resolve({});
};

const getOrgStatusTypes = () => {
	if (setHeader()) {
		return api.get('/admin/organizations/orgstatustypes');
	}

	return Promise.resolve({});
};

const getTimezones = () => {
	if (setHeader()) {
		return api.get('/admin/timezones');
	}

	return Promise.resolve({});
};

const getUserInfoById = (id) => {
	if (setHeader()) {
		return api.get('/user/getuserbyid', { user_id: id });
	}
	return Promise.resolve({});
};

const updateUserInfo = (userReducer) => {
	if (setHeader()) {
		return api.put('/admin/user/update', {
			additional_address: userReducer.address2,
			address: userReducer.address,
			alt_phone: userReducer.alternatePhoneNumber,
			city: userReducer.city,
			email: userReducer.email,
			emergency_contact_name: userReducer.emergency_contact_name,
			emergency_contact_phone: userReducer.emergency_contact_phone,
			emergency_contact_relationship: parseInt(userReducer.emergency_contact_relationship),
			emp_type: userReducer.employment,
			file_type: userReducer.file_type,
			first_name: userReducer.firstName,
			is_admin: userReducer.is_admin ? 'Y' : '',
			is_nurse: userReducer.is_nurse ? 'Y' : '',
			is_supervisor: userReducer.is_supervisor ? 'Y' : '',
			last_name: userReducer.lastName,
			password: userReducer.newPassword,
			phone: userReducer.primaryPhoneNumber,
			photo_location: userReducer.profileImagePath,
			referral_email: userReducer.referral_email,
			referral_name: userReducer.referral_name,
			role_id: parseInt(userReducer.role_id),
			security_code: userReducer.is_supervisor
				? userReducer.globalUserDetail.supervisor
					? userReducer.userOrgs[0].security_code !== null
						? userReducer.userOrgs[0].security_code
						: parseInt(userReducer.addUserAutoGenerateCode)
					: parseInt(userReducer.addUserAutoGenerateCode)
				: null,
			statcash_status: parseInt(userReducer.statcash_status),
			state: userReducer.state,
			status: userReducer.status,
			user_care_settings: userReducer?.user_care_settings?.map((item) => item.care_setting_id),
			user_id: parseInt(userReducer.user_id),
			user_notes: userReducer.note,
			utm_source: userReducer.utm_source,
			years_of_experience: (userReducer.years_of_experience_id && parseInt(userReducer.years_of_experience_id)) || 0,
			zip: userReducer.zipcode
		});
	}
	return Promise.resolve({});
};

const getOrgById = (id) => {
	if (setHeader()) {
		return api.get(`/admin/organization/${id}`);
	}
	return Promise.resolve({});
};

const getLocById = (id) => {
	if (setHeader()) {
		return api.get(`/admin/location/${id}`);
	}
	return Promise.resolve({});
};

const editSuspendUser = (id, endDate, endTime) => {
	if (setHeader()) {
		return api.put('/admin/user/editsuspend', {
			end_date: endDate,
			end_time: dayjs(endTime).format('HH:mm:ss'),
			user_id: id
		});
	}
	return Promise.resolve({});
};

const updateTestUser = (id, status) => {
	if (setHeader()) {
		return api.put('/admin/user/updatetestuser', {
			status,
			user_id: id
		});
	}
	return Promise.resolve({});
};

const updateIncetivePermissions = (user_id, permission) => {
	if (setHeader()) {
		return api.put('/admin/user/updateincentivepermissions', {
			permission,
			user_id
		});
	}
	return Promise.resolve({});
};

const suspendUser = (id, endDate, endTime) => {
	if (setHeader()) {
		return api.put('admin/user/suspend', {
			end_date: dayjs(endDate).format('YYYY-MM-DD'),
			end_time: dayjs(endTime).format('HH:mm:ss'),
			user_id: id
		});
	}
	return Promise.resolve({});
};

const unSuspendUser = (id) => {
	if (setHeader()) {
		return api.put('admin/user/unsuspend', { user_id: id });
	}
	return Promise.resolve({});
};

const setActiveUser = (id, isActive, reason) => {
	if (setHeader()) {
		return api.put(`admin/user/update-active-status/${id}`, {
			is_active: isActive,
			reason
		});
	}
	return Promise.resolve({});
};

const rejectUser = (id, reason) => {
	if (setHeader()) {
		return api.put('admin/user/reject', {
			reason,
			user_id: id
		});
	}
	return Promise.resolve({});
};

const approveUser = (id) => {
	if (setHeader()) {
		return api.put('admin/user/approved', { user_id: id });
	}
	return Promise.resolve({});
};

const setUserRemediation = (user_id) => {
	if (setHeader()) {
		return api.put('admin/user/remediation', { user_id });
	}
	return Promise.resolve({});
};

const createLocation = (
	location_id,
	organization_id,
	location_name,
	address,
	city,
	state,
	zip,
	phone_number,
	timezone_id,
	requirements = [],
	loc_emr = [],
	care_setting
) => {
	if (setHeader()) {
		return api.post('/admin/organizations/locations/addupdate', {
			address,
			care_setting,
			city,
			emr: loc_emr,
			location_id,
			location_name,
			organization_id,
			phone_number,
			requirements,
			state,
			timezone_id,
			zip
		});
	}
	return Promise.resolve({});
};

const getAllRequirements = (search_string, org_id, loc_id, dept_id, is_add, isCompanionReq = false) => {
	if (setHeader()) {
		let path = '/admin/filtered/requirement/search?search_string=';
		if (search_string !== undefined) {
			path = `${
				path + search_string
			}&org_id=${org_id}&loc_id=${loc_id}&dept_id=${dept_id}&companion_req=${isCompanionReq}&is_add=${is_add}`;
		} else {
			path = `${path}&org_id=${org_id}&loc_id=${loc_id}&dept_id=${dept_id}&companion_req=${isCompanionReq}&is_add=${is_add}`;
		}
		return api.get(path);
	}
	return Promise.resolve({});
};

const getOrgRequirements = (id) => {
	if (setHeader()) {
		return api.get(`/admin/organization/${id}/requirements`);
	}
	return Promise.resolve({});
};

const changeRequirementApproveState = (user_id, req_id, state) => {
	if (setHeader()) {
		return api.post('admin/requirement/approval', {
			isApproved: state,
			user_id,
			user_req_id: req_id
		});
	}
	return Promise.resolve({});
};

const changeRequesrApproveState = (user_id, req_id, user_req_id, state, reason, option) => {
	if (setHeader()) {
		return api.post('admin/request/approval', {
			comment: option,
			isApproved: state,
			reason,
			requirement_id: req_id,
			user_id,
			user_req_id
		});
	}
	return Promise.resolve({});
};

const deleteLocation = (locid) => {
	if (setHeader()) {
		return api.delete(`/admin/location/${locid}/remove`);
	}
	return Promise.resolve({});
};

const getConnectrnRequirement = () => {
	if (setHeader()) {
		return api.get('/requirements/connectrn');
	}
	return Promise.resolve({});
};

const assignReqToOrganization = (org_id, req_id, date_expr_interval, alt_req_id) => {
	if (!date_expr_interval) {
		date_expr_interval = '';
	}
	if (setHeader()) {
		return api.post(`/admin/org/requirements/${org_id}/${req_id}/assign`, {
			alt_req_id,
			date_expr_interval
		});
	}
	return Promise.resolve({});
};

const updateAssignReqToOrganization = (org_id, req_id, date_expr_interval, alt_req_id) => {
	if (!date_expr_interval) {
		date_expr_interval = '';
	}
	if (setHeader()) {
		return api.post(`/admin/org/requirements/${org_id}/${req_id}/updateassign`, {
			alt_req_id,
			date_expr_interval
		});
	}
	return Promise.resolve({});
};

const unassignReqToOrganization = (org_id, req_id) => {
	if (setHeader()) {
		return api.delete(`/admin/org/requirements/${org_id}/${req_id}/unassign`);
	}
	return Promise.resolve({});
};

const getLocationUser = (loc_id) => {
	if (setHeader()) {
		return api.get(`/admin/location/${loc_id}/users`);
	}
	return Promise.resolve({});
};

const removeOrgUser = (loc_id, user_id) => {
	if (setHeader()) {
		return api.delete(`/admin/loc/user/${loc_id}/${user_id}/remove`);
	}
	return Promise.resolve({});
};

const addUserToOrgByAdmin = (org_id, loc_id, dept_id, emp_type, user_id, nurse_pool_type, securityCode) => {
	if (setHeader()) {
		return api.post('/admin/organizations/user/add', {
			dept_id,
			emp_type,
			loc_id,
			nurse_pool_type,
			org_id,
			security_code: securityCode,
			user_id
		});
	}
	return Promise.resolve({});
};

const removeUserFromOrgByAdmin = (user_org_id) => {
	if (setHeader()) {
		return api.delete(`/admin/organizations/user/delete?id=${user_org_id}`);
	}
	return Promise.resolve({});
};

const updateUserOrgByAdmin = (org_id, loc_id, user_id, user_org_id, securityCode) => {
	if (setHeader()) {
		return api.put('/admin/organizations/user/update', {
			dept_id: null,
			emp_type: null,
			id: user_org_id,
			loc_id,
			org_id,
			security_code: securityCode,
			user_id
		});
	}
	return Promise.resolve({});
};

const getLocationRequirement = (loc_id) => {
	if (setHeader()) {
		return api.get(`/admin/location/${loc_id}/requirements`);
	}
	return Promise.resolve({});
};

const getDeptRequirement = (dept_id) => {
	if (setHeader()) {
		return api.get(`/admin/department/${dept_id}/requirements`);
	}
	return Promise.resolve({});
};

const assignReqToLoc = (loc_id, req_id) => {
	if (setHeader()) {
		return api.post(`/admin/loc/requirements/${loc_id}/${req_id}/assign`);
	}
	return Promise.resolve({});
};
const unassignReqToLoc = (loc_id, req_id) => {
	if (setHeader()) {
		return api.delete(`/admin/loc/requirements/${loc_id}/${req_id}/unassign`);
	}
	return Promise.resolve({});
};

// assigns additional requirement to location along with assigning required fields of that requirement for a location
const assignReqWithFieldsToLoc = (loc_id, reqID, reqFieldsData) => {
	if (setHeader()) {
		return api.post(`/admin/requirements/location-fields/${loc_id}`, {
			reqFieldsData,
			reqId: reqID
		});
	}
	return Promise.resolve({});
};

// assigns multi-option requirement to location.
const assignMultiReqWithFieldsToLoc = (loc_id, reqFieldsData) => {
	if (setHeader()) {
		return api.post(`/admin/requirements/location-fields/${loc_id}`, reqFieldsData);
	}
	return Promise.resolve({});
};

const updateReqWithFieldsToLoc = (loc_id, reqID, reqFieldsData) => {
	if (setHeader()) {
		return api.put(`/admin/requirements/location-fields/${loc_id}`, {
			reqFieldsData,
			reqId: reqID
		});
	}
	return Promise.resolve({});
};

const fetchLocRequiredFields = (locID) => {
	if (setHeader()) {
		return api.get(`/admin/requirements/location-fields/${locID}`);
	}
	return Promise.resolve({});
};

const assignReqToDept = (dept_id, req_id) => {
	if (setHeader()) {
		return api.post(`/admin/dep/requirements/${dept_id}/${req_id}/assign`);
	}
	return Promise.resolve({});
};
const unassignReqToDept = (dept_id, req_id) => {
	if (setHeader()) {
		return api.delete(`/admin/dep/requirements/${dept_id}/${req_id}/unassign`);
	}
	return Promise.resolve({});
};
const deleteDept = (dept_id) => {
	if (setHeader()) {
		return api.delete(`/admin/department/${dept_id}/remove`);
	}
	return Promise.resolve({});
};

const getShiftsWithPaging = (shift_state) => {
	if (setHeader()) {
		return api.get('/user/admin/shiftlist', {
			cancellationReason: shift_state.cancel_reason,
			department: shift_state.dept,
			from_date: shift_state.from_date !== '' ? formatDate.clientDateToYyMmDd(shift_state.from_date) : '',
			isndp: shift_state.isndp,
			location: shift_state.loc,
			nurse_id: shift_state.nurse_id,
			organization_id: shift_state.org,
			organization_status: shift_state.orgStatus,
			page_no: parseInt(shift_state.page_no),
			role: shift_state.role,
			searchString: shift_state.search_string,
			shift_id: shift_state.shift_id,
			sort: shift_state.sort,
			sortorder: shift_state.sortOrder,
			state: shift_state.state,
			status: shift_state.shift_status,
			supervisor: shift_state.supervisor_id,
			timezone: shift_state.timezone,
			to_date: shift_state.to_date !== '' ? formatDate.clientDateToYyMmDd(shift_state.to_date) : ''
		});
	}
	return Promise.resolve({});
};

const getTimesheetsWithPaging = (timesheet_state) => {
	if (setHeader()) {
		const status = Array.isArray(timesheet_state.shift_status)
			? timesheet_state.shift_status.join()
			: timesheet_state.shift_status;

		return api.get('/admin/timesheets', {
			approval_method: timesheet_state.approval_method,
			breaks: timesheet_state.breaks,
			care_setting_type_ids: timesheet_state.care_setting_type_id.join().replaceAll(' ', ''),
			department_id: timesheet_state.dept,
			from_date: timesheet_state.from_date !== '' ? formatDate.clientDateToYyMmDd(timesheet_state.from_date) : '',
			isndp: timesheet_state.sort_ndp,
			location_id: timesheet_state.loc,
			nurse: timesheet_state.nurse,
			organization_id: timesheet_state.org,
			// eslint-disable-next-line radix
			page_no: parseInt(timesheet_state.page_no),
			pending_filters: timesheet_state.pending_filters,
			pending_reason: timesheet_state.pending_reason,
			processed_reason: timesheet_state.processed_reason,
			processing_method_id: timesheet_state.processing_method_id,
			role: timesheet_state.role,
			searchString: timesheet_state.search_string,
			shift_id: timesheet_state.shift_id,
			sort: timesheet_state.sort,
			sortorder: timesheet_state.sortOrder,
			statcash: timesheet_state.statcash,
			status,
			supervisor: timesheet_state.supervisor_id,
			timesheet_id: timesheet_state.timesheet_id,
			to_date: timesheet_state.to_date !== '' ? formatDate.clientDateToYyMmDd(timesheet_state.to_date) : ''
		});
	}
	return Promise.resolve({});
};

const createDepartment = ({
	careSetting,
	departmentRequirements = [],
	rateTypes,
	departmentId,
	departmentName,
	locationId
}) => {
	if (setHeader()) {
		return api.post('/admin/organizations/departments/addupdate', {
			care_setting: careSetting,
			department_id: departmentId,
			dept_name: departmentName,
			location_id: locationId,
			rate_types: rateTypes,
			requirements: departmentRequirements
		});
	}
	return Promise.resolve({});
};

const UpdateDeptName = (department_id, dept_name) => {
	if (setHeader()) {
		return api.post('/admin/organizations/departments/updatename', {
			department_id,
			dept_name
		});
	}
	return Promise.resolve({});
};
const searchUsers = (location_id, search) => {
	if (setHeader()) {
		return api.get(`/admin/usersearch?location_id=${location_id}&search=${search}`);
	}
	return Promise.resolve({});
};

const getShiftRequirements = (shift_id) => {
	if (setHeader()) {
		return api.get(`/requirements/shiftrequirement?shift_id=${shift_id}`);
	}
	return Promise.resolve({});
};

const getPendingRequests = (page_no, sort, sortorder) => {
	if (setHeader()) {
		return api.get(`/requests/pending?page_no=${page_no}&sort=${sort}&sortorder=${sortorder}`);
	}
	return Promise.resolve({});
};

const getOldRequests = (page_no, sort, sortorder) => {
	if (setHeader()) {
		return api.get(`/requests/closed?page_no=${page_no}&sort=${sort}&sortorder=${sortorder}`);
	}
	return Promise.resolve({});
};

const updateNurseDetails = (nurseReducer) => {
	if (setHeader()) {
		return api.put('/user/nursedetails/update', {
			additional_address: nurseReducer.address2,
			address: nurseReducer.address,
			alt_phone: nurseReducer.alternatePhoneNumber,
			city: nurseReducer.city,
			file_type: nurseReducer.profileImageFileType,
			first_name: nurseReducer.firstName,
			last_name: nurseReducer.lastName,
			new_password: nurseReducer.newPassword !== '' ? nurseReducer.newPassword : null,
			old_password: nurseReducer.oldPassword !== '' ? nurseReducer.oldPassword : null,
			phone: nurseReducer.primaryPhoneNumber,
			photo_location: nurseReducer.profileImagePreview,
			role_id: parseInt(nurseReducer.role_id),
			state: nurseReducer.state,
			user_id: parseInt(nurseReducer.user_id),
			years_of_experience: parseInt(nurseReducer.years_of_experience_id) || 0,
			zip: nurseReducer.zipcode
		});
	}
	return Promise.resolve({});
};

const updateSupervisorDetails = (userInfo) => {
	if (setHeader()) {
		return api.put('/user/supervisordetails/update', {
			additional_address: userInfo.address2,
			address: userInfo.address,
			alt_phone: userInfo.alternatePhoneNumber,
			city: userInfo.city,
			file_type: userInfo.profileImageFileType,
			first_name: userInfo.firstName,
			last_name: userInfo.lastName,
			new_password: userInfo.newPassword !== '' ? userInfo.newPassword : null,
			old_password: userInfo.oldPassword !== '' ? userInfo.oldPassword : null,
			phone: userInfo.primaryPhoneNumber,
			photo_location: userInfo.profileImagePreview,
			state: userInfo.state,
			user_id: parseInt(userInfo.user_id),
			zip: userInfo.zipcode
		});
	}
	return Promise.resolve({});
};

const addNurseRequirement = (requirement_id, user_docs = [], user_fields = [], show_on_req = true) => {
	if (setHeader()) {
		return api.post('nurse/requirements/add', {
			requirement_id: parseInt(requirement_id),
			show_on_req,
			user_docs,
			user_fields
		});
	}
	return Promise.resolve({});
};

const getNurseRequirements = () => {
	if (setHeader()) {
		return api.get('/nurse/requirements');
	}
	return Promise.resolve({});
};

const updateNurseRequirement = (requirement_id, user_docs = [], user_fields = [], show_on_req = true) => {
	if (setHeader()) {
		return api.put('nurse/requirements/update', {
			requirement_id: parseInt(requirement_id),
			show_on_req,
			user_docs,
			user_fields
		});
	}
	return Promise.resolve({});
};

const deleteRequirementByNurse = (user_id, req_id) => {
	if (setHeader()) {
		return api.delete(`/nurse/requirement/remove?user_id=${user_id}&req_id=${req_id}`);
	}
	return Promise.resolve({});
};

const addUserToOrg = (org_id, loc_id, dept_id, emp_type, user_list = [], nurse_pool_type) => {
	if (setHeader()) {
		return api.post('admin/organizations/addusers', {
			dept_id,
			emp_type,
			loc_id,
			nurse_pool_type,
			org_id,
			user_list
		});
	}
	return Promise.resolve({});
};

const deleteReqDocumentById = (req_doc_id) => {
	if (setHeader()) {
		return api.delete(`/user/requirements/deletedocument/${req_doc_id}`);
	}
	return Promise.resolve({});
};

const addNurseOnboardingRequirement = (requirements = []) => {
	if (setHeader()) {
		return api.post('/onboarding/requirements', {
			requirements
		});
	}
	return Promise.resolve({});
};
const skipNurseOnboardingRequirement = (requirements = []) => {
	if (setHeader()) {
		return api.post('/onboarding/requirements/skip', {
			requirements
		});
	}
	return Promise.resolve({});
};

const nurseShiftCheckIn = (id, lat, lng) => {
	if (setHeader()) {
		return api.post('/nurse/timesheet/checkin', {
			checkin_lat: lat,
			checkin_lng: lng,
			shift_id: id
		});
	}
	return Promise.resolve({});
};
const nurseCheckout = (id, note, checkout_lat, checkout_lng) => {
	if (setHeader()) {
		return api.put('/nurse/timesheet/checkout', {
			checkout_lat,
			checkout_lng,
			id,
			note
		});
	}
	return Promise.resolve({});
};
const nurseShiftTimesheet = (shift_id) => {
	if (setHeader()) {
		return api.get(`/nurse/shift/timesheet?shift_id=${shift_id}`);
	}
	return Promise.resolve({});
};
const addTimesheetComponent = (
	timesheet_id,
	component_type,
	from_date,
	to_date,
	item,
	break_exception_type_id,
	break_exception_comment
) => {
	if (setHeader()) {
		return api.post('/nurse/shift/timesheet/component/add', {
			break_exception_comment,
			break_exception_type_id,
			component_type,
			from_date,
			item,
			timesheet_id,
			to_date
		});
	}
	return Promise.resolve({});
};
const getTimesheetComponents = (timesheet_id) => {
	if (setHeader()) {
		return api.get(`/nurse/shift/timesheet/components?timesheet_id=${timesheet_id}`);
	}
	return Promise.resolve({});
};
const deleteTimesheetComponent = (id) => {
	if (setHeader()) {
		return api.delete(`/nurse/shift/timesheet/component/delete/${id}`);
	}
	return Promise.resolve({});
};

const getSupervisorTimesheetsWithPaging = (timesheet_state) => {
	if (setHeader()) {
		return api.get('/supervisor/timesheets', {
			department_id: timesheet_state.department_id,
			from_date: timesheet_state.from_date !== '' ? formatDate.clientDateToYyMmDd(timesheet_state.from_date) : '',
			location_id: timesheet_state.location_id,
			nurse: timesheet_state.nurse,
			page_no: parseInt(timesheet_state.page_no),
			shift_id: timesheet_state.shift_id,
			sort: timesheet_state.sort,
			sortorder: timesheet_state.sortOrder,
			status: timesheet_state.status,
			to_date: timesheet_state.to_date !== '' ? formatDate.clientDateToYyMmDd(timesheet_state.to_date) : ''
		});
	}
	return Promise.resolve({});
};
const getTimesheetNotes = (timesheet_id) => {
	if (setHeader()) {
		return api.get(`/nurse/shift/timesheet/notes?timesheet_id=${timesheet_id}`);
	}
	return Promise.resolve({});
};
const addComments = (timesheet_id, message, message_type) => {
	if (setHeader()) {
		return api.post('/nurse/shift/timesheet/note', {
			message,
			message_type,
			timesheet_id
		});
	}
	return Promise.resolve({});
};

const getSupervisorTimesheetDetail = (timesheetid) => {
	if (setHeader()) {
		return api.get(`/supervisor/gettimesheet?timesheet_id=${timesheetid}`);
	}
	return Promise.resolve({});
};

const getRatingQuestions = (quefor) => {
	if (setHeader()) {
		return api.get(`/rating/getRatingQuestions?que_for=${quefor}`);
	}
	return Promise.resolve({});
};

const dismissOrgRatingQuestions = (org_id) => {
	if (setHeader()) {
		if (org_id !== null && org_id !== '' && org_id !== undefined && org_id !== 0) {
			return api.post('/rating/dismissOrganizationRating', {
				org_id
			});
		}
	}
	return Promise.resolve({});
};

const dismissNurseRatingQuestions = (nurse_id, shift_id, user_id) => {
	if (setHeader()) {
		return api.post('/rating/dismissNurseRating', {
			nurse_id,
			shift_id,
			user_id
		});
	}
	return Promise.resolve({});
};

const submitNurseRatingQuestions = (nurse_id, que_id, shift_id, user_id, answer_id, reason, notes) => {
	if (setHeader()) {
		return api.post('/rating/submitNurseRatingV2', {
			answer_id,
			notes,
			nurse_id,
			que_id,
			reason,
			shift_id,
			user_id
		});
	}
	return Promise.resolve({});
};

const approveTimesheet = (
	id,
	adjusted_start_time,
	adjusted_end_time,
	status,
	supervisor_name,
	mileage,
	shift_type,
	tasks,
	task_hours,
	additional_points
) => {
	if (setHeader()) {
		return api.put('/supervisor/approvedtimesheet', {
			additional_points,
			adjusted_end_time,
			adjusted_start_time,
			id,
			mileage,
			shift_type,
			status,
			supervisor_name,
			task_hours,
			tasks
		});
	}
	return Promise.resolve({});
};
const updateComponent = (id, from_date, to_date, remark, item, break_exception_type_id, break_exception_comment) => {
	if (setHeader()) {
		return api.put('/nurse/shift/timesheet/component/update', {
			break_exception_comment,
			break_exception_type_id,
			from_date,
			id,
			item,
			remark,
			to_date
		});
	}
	return Promise.resolve({});
};

const markAsPaid = (id, adjusted_start_time, adjusted_end_time) => {
	if (setHeader()) {
		return api.put('/admin/paidtimesheet', {
			adjusted_end_time,
			adjusted_start_time,
			id
		});
	}
	return Promise.resolve({});
};

const markAsIneligible = (id, status) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.put(`/admin/timesheet/update/${id}`, {
		status
	});
};

const updateTimesheetStatus = (id, status) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.put(`/admin/timesheet/update/${id}`, {
		status
	});
};

const updateTimesheetStatusAndTime = (id, status, adjusted_end_time, adjusted_start_time) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.put(`/admin/timesheet/updatestatusandtime/${id}`, {
		adjusted_end_time,
		adjusted_start_time,
		status
	});
};

const supervisorDashboardDay = (org_id, location_id, date, search_string) => {
	if (setHeader()) {
		return api.get(
			`/supervisor/shifts/bydate?date=${date}&location_id=${location_id}&search_string=${search_string}&organization_id=${org_id}`
		);
	}
	return Promise.resolve({});
};

const supervisorShiftsForQuickActions = (org_id, location_id) => {
	if (setHeader()) {
		return api.get(`/supervisor/shifts/quick-actions?location_id=${location_id}&organization_id=${org_id}`);
	}
	return Promise.resolve({});
};

const getOrgFeatures = (org_id) => {
	if (setHeader()) {
		if (org_id !== null && org_id !== '') {
			return api.get('/orgfeatures', {
				org_id
			});
		}
	}
	return Promise.resolve({});
};
const updateFeatureStatus = (org_id, feature_id, status) => {
	if (setHeader()) {
		return api.put('/orgfeature/update', {
			feature_id,
			org_id,
			status
		});
	}
	return Promise.resolve({});
};

const supervisorShiftSearch = (org_id, search_string, rand) => {
	if (setHeader()) {
		return api.get(`/supervisor/search?orgid=${org_id}&query=${search_string}&api_req_id=${rand}`);
	}
	return Promise.resolve({});
};

const updateShift = (shiftObj = {}) => {
	if (setHeader()) {
		return api.put('/shifts/update', shiftObj);
	}
	return Promise.resolve({});
};

const getNurseShiftHistory = (nurse_id, props = null) => {
	let param = { nurse_id };
	if (props) {
		param = {
			...param,
			...props
		};
	}
	if (setHeader()) {
		return api.get('/nurse/shifthistory', param);
	}

	return Promise.resolve({});
};

const updateShiftVisibility = (preference_id, status) => {
	if (setHeader()) {
		return api.put('/user/visibility', {
			preference_id,
			status
		});
	}
	return Promise.resolve({});
};

const getAuditLogs = (shift_id, term) => {
	if (setHeader()) {
		return api.get(`/shifts/log?shift_id=${shift_id}&term=${term}`);
	}
	return Promise.resolve({});
};

const getDnrList = (page_no, sort, sort_order, search, nurse_id) => {
	if (setHeader()) {
		return api.get('/admin/dnrlist', {
			nurse_id,
			page_no,
			search,
			sort,
			sort_order
		});
	}
	return Promise.resolve({});
};

const deleteDNR = (dnr_id) => {
	if (setHeader()) {
		return api.delete(`/admin/deletednr?dnr_id=${dnr_id}`);
	}
	return Promise.resolve({});
};

const getPublicDNRReason = (token, type) => {
	api.setHeader('Authorization', `Bearer ${token}`);
	return api.get(`/admin/getreasons?reason_type=${type}`);
};

const getDNRReason = (type) => {
	if (setHeader()) {
		return api.get(`/admin/getreasons?reason_type=${type}`);
	}
	return Promise.resolve({});
};

const autoSearchNurse = (search) => {
	if (setHeader()) {
		return api.get(`/admin/nursesearch?search=${search}`);
	}
	return Promise.resolve({});
};
const createDnr = (user_id, org_id, loc_id, dept_ids, reason) => {
	if (setHeader()) {
		return api.post('/admin/creatednr', {
			dept_ids,
			loc_id,
			org_id,
			reason,
			user_id
		});
	}
	return Promise.resolve({});
};

const getAcceptedNApplied = (user_id, depts) => {
	if (setHeader()) {
		return api.get(`/shifts/acceptedandapplied?user_id=${user_id}&depts=${depts}`);
	}
	return Promise.resolve({});
};

const getEditUsershiftList = (user_id, suspendEndDate, suspendEndTime, default_suspend_start_date) => {
	if (setHeader()) {
		return api.get(`/shifts/acceptedandapplied?user_id=${user_id}`, {
			default_suspend_start_date,
			suspendEndDate: dayjs(suspendEndDate).format('YYYY-MM-DD'),
			suspendEndTime: dayjs(suspendEndTime).format('HH:mm:ss')
		});
	}
	return Promise.resolve({});
};

const publicRejectShiftApplicantWithReason = (token, user_id, shift_id, reason) => {
	api.setHeader('Authorization', `Bearer ${token}`);
	if (!reason || reason == '') {
		reason = 'Other';
	}
	return api.delete('/user/rejectshiftapplicant', {
		reason,
		shift_id,
		user_id
	});
};

const rejectShiftApplicantWithReason = (user_id, shift_id, reason, reason_text) => {
	if (setHeader()) {
		return api.delete('/user/rejectshiftapplicant', {
			reason,
			reason_text,
			shift_id,
			user_id
		});
	}
	return Promise.resolve({});
};

const publicUndoRejectShiftApplicant = (token, user_id, shift_id) => {
	api.setHeader('Authorization', `Bearer ${token}`);
	return api.put('/user/undorejectshiftapplicant', {
		nurse_id: user_id,
		shift_id
	});
};

const updateBackfillShiftFeature = (shift_id, feature_id, status, nurse_id, case_type, token) => {
	api.setHeader('Authorization', `Bearer ${token}`);
	return api.put('/shift/feature', {
		case_type,
		feature_id,
		nurse_id,
		shift_id,
		status
	});
};

const undoRejectShiftApplicant = (user_id, shift_id) => {
	if (setHeader()) {
		return api.put('/user/undorejectshiftapplicant', {
			nurse_id: user_id,
			shift_id
		});
	}
	return Promise.resolve({});
};

const requestShiftApplicant = (user_id, shift_id) => {
	if (setHeader()) {
		return api.post('/nurse/shifts/requests', {
			nurse_id: user_id,
			shift_ids: [shift_id]
		});
	}
	return Promise.resolve({});
};

const getUserFeatures = () => {
	if (setHeader()) {
		return api.get('/features/user');
	}
	return Promise.resolve({});
};

const getGlobalFeatures = () => {
	if (setHeader()) {
		return api.get('/features/global');
	}
	return Promise.resolve({});
};

const updateUserFeature = (featureId, feature) => {
	const { is_active, percentage } = feature;
	if (setHeader()) {
		return api.put(`/features/${featureId}`, { is_active, percentage });
	}
	return Promise.resolve({});
};

const getUserByFeatureId = (featureId) => {
	if (setHeader()) {
		return api.get(`/user/features/${featureId}`);
	}
	return Promise.resolve({});
};

const getUserByFeatureIdWithEmail = (featureId, email) => api.post(`/user/features/${featureId}`, { email });

const saveShiftForLater = (shift_id) => {
	if (setHeader()) {
		return api.post('/user/bookmark', {
			shift_id
		});
	}
	return Promise.resolve({});
};

const getSavedShifts = (
	page_no,
	status,
	organization,
	location,
	department,
	supervisor,
	from_date,
	to_date,
	zip_code,
	sort,
	sortorder,
	distance,
	approvalStatus,
	shiftId,
	shift_accepted_status
) => {
	if (setHeader()) {
		return api.get('/user/bookmark', {
			approvalStatus,
			department,
			distance,
			fromDate: from_date,
			location,
			organization,
			pageNo: page_no,
			shift_accepted_status,
			shiftId,
			sortBy: sort || 'id',
			sortOrder: sortorder || 'desc',
			supervisor,
			toDate: to_date,
			zipCode: zip_code
		});
	}
	return Promise.resolve({});
};

const deleteSavedShift = (id) => {
	if (setHeader()) {
		return api.delete(`/user/bookmark/${id}`);
	}
	return Promise.resolve({});
};

const getNotCheckinTimesheet = (timesheet_state) => {
	if (setHeader()) {
		return api.get('/admin/notcheckedintimesheets', {
			department_id: timesheet_state.dept,
			from_date: timesheet_state.from_date !== '' ? formatDate.clientDateToYyMmDd(timesheet_state.from_date) : '',
			location_id: timesheet_state.loc,
			nurse: timesheet_state.nurse,
			organization_id: timesheet_state.org,
			page_no: parseInt(timesheet_state.page_no),
			role: timesheet_state.role,
			searchString: timesheet_state.search_string,
			shift_id: timesheet_state.shift_id,
			sort: timesheet_state.sort,
			sortorder: timesheet_state.sortOrder,
			supervisor: timesheet_state.supervisor_id,
			to_date: timesheet_state.to_date !== '' ? formatDate.clientDateToYyMmDd(timesheet_state.to_date) : ''
		});
	}
	return Promise.resolve({});
};

const updateSecurityCode = (org_id, old_security_code, new_security_code) => {
	if (setHeader()) {
		return api.put('/supervisor/updatesecuritycode', {
			new_security_code,
			old_security_code,
			org_id
		});
	}
	return Promise.resolve({});
};

const updateSecurityCodeByAdmin = (org_id, old_security_code, new_security_code, user_id) => {
	if (setHeader()) {
		return api.put('/admin/updatesecuritycodebyadmin', {
			new_security_code,
			old_security_code,
			org_id,
			user_id
		});
	}
	return Promise.resolve({});
};

const publicCheckBackToBack = (token, user_id, shift_id) => {
	api.setHeader('Authorization', `Bearer ${token}`);
	return api.post('/user/checkbacktoback', {
		shift_id,
		user_id
	});
};

const checkBackToBack = (user_id, shift_id) => {
	if (setHeader()) {
		return api.post('/user/checkbacktoback', {
			shift_id,
			user_id
		});
	}
	return Promise.resolve({});
};

const checkCredentialExpire = () => {
	if (setHeader()) {
		return api.get('/nurse/checkcredentialexpire');
	}
	return Promise.resolve({});
};

const getUserDefaultPreferences = () => {
	if (setHeader()) {
		return api.get('/user/GetDefaultPreferences');
	}
	return Promise.resolve({});
};

const getUserPreferences = () => {
	if (setHeader()) {
		return api.get('/user/GetPreferences');
	}
	return Promise.resolve({});
};

const saveUserPreferences = (userPref) => {
	if (setHeader()) {
		return api.post('/user/SetPreferences', userPref);
	}
	return Promise.resolve({});
};

const getSuperPrefForOrganization = (orgId) => {
	if (setHeader()) {
		return api.get(`/admin/organizations/supervisorlist/${orgId}`);
	}
	return Promise.resolve({});
};

const supervisorTimesheetCheckout = function ({
	// Tell TS this should be a string
	adjustedEndTime = '',
	adjustedStartTime = '',
	breaksList = [],
	checkoutAccuracy = null,
	checkoutLat,
	checkoutLng,
	comment,
	checkoutTime,
	nurseID,
	shiftID,
	supervisorFullName
}) {
	// Convert to nulls if empty strings
	adjustedEndTime = adjustedEndTime || null;
	adjustedStartTime = adjustedStartTime || null;
	if (setHeader()) {
		return api.put('/supervisor/timesheets/checkout', {
			adjusted_end_time: adjustedEndTime,
			adjusted_start_time: adjustedStartTime,
			breaks: breaksList,
			checkout_accuracy: checkoutAccuracy,
			checkout_lat: checkoutLat,
			checkout_lng: checkoutLng,
			checkout_time: checkoutTime,
			comment,
			nurse_id: nurseID,
			shift_id: shiftID,
			supervisor_name: supervisorFullName
		});
	}
	return Promise.resolve({});
};

const saveEditedTimesheet = (
	id,
	adjusted_end_time,
	adjusted_start_time,
	comment,
	supervisor_name,
	mileage,
	shift_type,
	tasks,
	task_hours,
	additional_points
) => {
	if (setHeader()) {
		return api.put('/supervisor/savetimesheet', {
			additional_points,
			adjusted_end_time,
			adjusted_start_time,
			comment,
			id,
			mileage,
			shift_type,
			supervisor_name,
			task_hours,
			tasks
		});
	}
	return Promise.resolve({});
};

const deleteAllReqDocument = (req_id) => {
	if (setHeader()) {
		return api.delete(`/user/requirements/deletealldocument/${req_id}`);
	}
	return Promise.resolve({});
};
const saveSuperPrefForOrganization = (orgId, userPref) => {
	if (setHeader()) {
		return api.post(`/admin/organizations/SetSupervisorlist/${orgId}`, userPref);
	}
	return Promise.resolve({});
};
const updateShiftFeature = (shift_id, feature_id, status) => {
	if (setHeader()) {
		return api.put('/shift/feature', {
			feature_id,
			shift_id,
			status
		});
	}
	return Promise.resolve({});
};

const updateShiftFeatureByName = (shift_id, feature_name, status) => {
	if (setHeader()) {
		return api.put('/shift/feature_name', {
			feature_name,
			shift_id,
			status
		});
	}
	return Promise.resolve({});
};

const updateNurseFeatureByName = (user_id, feature_name, status) => {
	if (setHeader()) {
		return api.put('/user/feature_name', {
			feature_name,
			status,
			user_id
		});
	}
	return Promise.resolve({});
};

const updateUserBeatAdmin = (user_id, status) => {
	if (setHeader()) {
		return api.put(`/user/beat_admin`, {
			status,
			user_id
		});
	}
	return Promise.resolve({});
};

const getLoyaltyLevel = () => {
	if (setHeader()) {
		return api.get('/loyalty/levels');
	}
	return Promise.resolve({});
};

const getLoyaltyEventsByNurseId = (id, fromDate, toDate) => {
	if (setHeader()) {
		return api.get(`/user/loyalty-events/${id}`, {
			from: fromDate,
			to: toDate
		});
	}
	return Promise.resolve({});
};

const getFilters = () => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.get('/filtersv2');
};
const getSavedFilter = () => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.get('/getsavedfilters');
};

const deleteFilter = (savedfilterid) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.delete(`/filter?savedfilterid=${savedfilterid}`);
};
const savefilter = (name, is_default, values) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.post('/savefilter', {
		is_default,
		name,
		values
	});
};

// Report error and feedback
const reportError = (report) => {
	if (setHeader()) {
		return api.post('/feedback', report);
	}

	return Promise.resolve({});
};

const assignNurseToShift = (shiftId, nurseId) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.post(`/admin/shifts/${shiftId}/apply`, {
		nurse_id: nurseId
	});
};

const createShiftAndAssign = (data) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.post('/admin/shift/create/apply', data);
};

const getNPSQuestion = () => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.get('/nps/available');
};

const submitNPS = (npsData) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.post('/nps/submit', npsData);
};

const getAvailableNps = () => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.get('/nps');
};

const activateNps = (id, active) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.put(`/nps/${id}/activate`, { activate: active });
};

const processTimesheets = (processing_method, timesheet_ids, filters) => {
	if (setHeader()) {
		return api.put(
			`/admin/timesheets/processall?${queryString.stringify({
				approval_method: filters?.approval_method,
				from_date: filters?.from_date,
				nurse: filters?.nurse,
				organization_id: filters?.org,
				page_no: filters?.page_no,
				processing_method,
				role: filters?.role,
				shift_id: filters?.shift_id,
				sort: filters?.sort,
				sortorder: filters?.sortOrder,
				statcash: filters?.statcash,
				status: filters?.shift_status,
				timesheet_ids,
				to_date: filters?.to_date
			})}`
		);
	}
	return Promise.resolve({});
};

const markAllAsPaid = (timesheet_state) => {
	if (setHeader()) {
		return api.put(
			`/admin/timesheets/payall?${queryString.stringify({
				from_date: timesheet_state.from_date,
				nurse: timesheet_state.nurse,
				organization_id: timesheet_state.org,
				page_no: parseInt(timesheet_state.page_no),
				processed_reason: timesheet_state.processedReasonFilters,
				role: timesheet_state.role,
				shift_id: timesheet_state.shift_id,
				sort: timesheet_state.sort,
				sortorder: timesheet_state.sortOrder,
				statcash: timesheet_state.statcash,
				status: timesheet_state.shift_status,
				timesheet_id: timesheet_state.timesheet_id,
				timesheet_ids: timesheet_state.timesheets_id,
				to_date: timesheet_state.to_date
			})}`
		);
	}
	return Promise.resolve({});
};

// Download CSV
const downloadCSV = (url, params) =>
	axiosInstance({
		headers: {
			Authorization: `Bearer ${token()}`
		},
		method: 'GET',
		params,
		responseType: 'blob',
		url
	});

const deleteResumeByNurseUser = (resumeID) => {
	if (setHeader()) {
		return api.delete(`/nurse/deleteresume?resume_id=${resumeID}`);
	}
	return Promise.resolve({});
};

// Update STATCash Status
const updateUserSTATCashStatus = (id, statusID) => {
	if (setHeader()) {
		return api.post('/admin/statcash/status', {
			statcash_status_id: parseInt(statusID),
			user_id: id
		});
	}
	return Promise.resolve({});
};

// EMR
const getEMRList = () => {
	if (setHeader()) {
		return api.get('/emr');
	}
	return Promise.resolve({});
};

const openShifts = (
	page_no,
	from_date,
	to_date,
	zip_code,
	sort,
	sortorder,
	distance,
	days,
	locationids,
	times,
	search,
	_excludeWaitlist,
	_onlyRecommended
) => {
	if (setHeader()) {
		return api.get('/user/openshifts', {
			days,
			distance,
			exclude_waitlist: _excludeWaitlist,
			from_date,
			is_recommended: _onlyRecommended,
			locationids,
			page_no,
			search,
			sort,
			sortorder,
			times,
			to_date,
			zip_code
		});
	}
	return Promise.resolve({});
};

const updateLocationDetails = (locId, locationDetails) => {
	const apiUrl = `/admin/location/${locId}/details`;
	if (setHeader()) {
		return api.put(apiUrl, locationDetails);
	}

	return Promise.resolve({});
};

const adminUploadFileToS3 = (file, category) => {
	if (setHeader()) {
		api.setHeader('Content-Type', 'multipart/form-data');

		const data = new FormData();
		data.append('file', file);
		if (category !== '') {
			data.append('category', category);
		}

		return api.post('/file', data);
	}
	return Promise.resolve({});
};

const getFullShiftHistory = (nurseID) => {
	if (setHeader()) {
		return api.get(`/nurse/full-shift-history?nurse_id=${nurseID || ''}`);
	}

	return Promise.resolve({});
};

const getLoyaltyRewards = () => {
	if (setHeader()) {
		return api.get('/loyalty/loyaltylevelandfaqs');
	}

	return Promise.resolve({});
};

const updateshiftcalloutexcuse = (nurse_id, shift_id, is_excused) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.put('/user/updateshiftcalloutexcuse', {
		is_excused,
		nurse_id,
		shift_id
	});
};

const updateUserHazardPay = (nurse_id, shift_id, is_hazard_pay_enabled, org_id) => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.put('/user/updateuserhazardpay', {
		is_hazard_pay_enabled,
		nurse_id,
		org_id,
		shift_id
	});
};

const shiftcalloutexcuse = () => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.get('/user/shiftcalloutexcuse');
};

const getIsRedirectToFountain = () => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.get('/user/showredirecttofountain');
};

const getStates = () => {
	if (setHeader()) {
		return api.get('/states');
	}
	return Promise.resolve({});
};
const getIsShiftForceFilter = () => {
	api.setHeader('Authorization', `Bearer ${token()}`);
	return api.get('/user/webshiftspageforcefilteruser');
};

const getStatusHistory = (nurse_id) => {
	if (setHeader()) {
		return api.get('/user/nurse/accountactivity', { nurse_id });
	}
	return Promise.resolve({});
};

const adminTimesheetCheckin = (options) => {
	if (setHeader()) {
		return api.post('/admin/timesheet/checkin', {
			added_by: options.added_by,
			checkin_time: options.checkin_time,
			note: options.note,
			shiftID: options.shiftID
		});
	}
	return Promise.resolve({});
};

const getAdminShiftTimes = async (locationId) => {
	if (setHeader()) {
		return api.get(`/admin/locationshifttimes/${locationId}`);
	}
	return Promise.resolve({});
};

const updateAdminShiftTime = async (shiftTime) => {
	if (setHeader()) {
		return api.put('/admin/locationshifttimes', {
			...shiftTime
		});
	}
	return Promise.resolve({});
};
const deleteAdminShiftTime = async (shiftTimeId) => {
	if (setHeader()) {
		return api.delete(`/admin/locationshifttimes/${shiftTimeId}`);
	}
	return Promise.resolve({});
};

const removePositionFromShift = (shift_id, nurse_id, token) => {
	api.setHeader('Authorization', `Bearer ${token}`);
	return api.put('/shift/remove-position/' + shift_id, {
		nurse_id
	});
};

const getAdminAccessLevels = async () => {
	if (setHeader()) {
		return api.get('/access-levels');
	}
	return Promise.resolve({});
};

const searchAdminAccessLevels = async (search) => {
	if (setHeader()) {
		return api.get('/access-levels', { search });
	}
	return Promise.resolve({});
};

const getScopes = async () => {
	if (setHeader()) {
		return api.get('/scopes');
	}
	return Promise.resolve({});
};

const getAccessLevelScopes = async (id) => {
	if (setHeader()) {
		return api.get('/access-levels/' + id + '/scopes');
	}
	return Promise.resolve({});
};

const createAccessLevel = async (accessLevel, scopes) => {
	if (setHeader()) {
		const accessLevelResp = await api.post('/access-levels', accessLevel);
		await api.post('/access-levels/' + accessLevelResp.data.id + '/scopes', { scopes });
		await api.post('/admin/refresh-permissions-cache');
	}
	return Promise.resolve({});
};

const updateAccessLevel = async (accessLevel) => {
	if (setHeader()) {
		await api.put('/access-levels/' + accessLevel.id, { ...accessLevel, id: undefined });
		await api.post('/admin/refresh-permissions-cache');
	}
	return Promise.resolve({});
};

const updateAccessLevelScopes = async (id, scopes) => {
	if (setHeader()) {
		await api.put('/access-levels/' + id + '/scopes', { scopes });
		await api.post('/admin/refresh-permissions-cache');
	}
	return Promise.resolve({});
};

// the endpoint supports only nurse ids
const downloadUserProfile = async (nurseID, locationID, shiftID) =>
	axiosInstance({
		headers: {
			Authorization: `Bearer ${token()}`
		},
		method: 'GET',
		params: { locationID, shiftID },
		responseType: 'blob',
		url: `/api/v3/user/profile/downloadPDF/${nurseID}`
	});

// the endpoint will fetch self co qr links
const getQRLink = async (date) => {
	let path = '/qr-code-url';
	if (date) {
		path += `?date=${date}`;
	}
	if (setHeader()) {
		return api.get(path);
	}
	return Promise.resolve({});
};

const Agent = {
	acceptPublicShiftApplicant,
	acceptShiftApplicant,
	activateNps,
	addComments,
	addNurseOnboardingRequirement,
	addNurseRequirement,
	addRequirement,
	addTimesheetComponent,
	addUserRequirement,
	addUserToOrg,
	addUserToOrgByAdmin,
	adminTimesheetCheckin,
	adminUploadFileToS3,
	applyShift,
	approveTimesheet,
	approveUser,
	assignMultiReqWithFieldsToLoc,
	assignNurseToShift,
	assignReqToDept,
	assignReqToLoc,
	assignReqToOrganization,
	assignReqWithFieldsToLoc,
	autoSearchNurse,
	calloutShift,
	calloutShiftByAdmin,
	changeRequesrApproveState,
	changeRequirementApproveState,
	checkBackToBack,
	checkCredentialExpire,
	commonFileUpload,
	createAccessLevel,
	createAlert,
	createDepartment,
	createDnr,
	createJobHistoryByNurse,
	createLocation,
	createMultiTimeShifts,
	createNewShift,
	createOrganization,
	createOrganizationAcquisition,
	createShiftAndAssign,
	createShifts,
	createUserInstance,
	createUserJobHistory,
	CSType,
	deleteAdminShiftTime,
	deleteAllReqDocument,
	deleteDept,
	deleteDNR,
	deleteFilter,
	deleteLocation,
	deleteLocationsSettings,
	deleteNotices,
	deleteOrgSettings,
	deleteReqDocumentById,
	deleteRequirement,
	deleteRequirementByNurse,
	deleteResumeByNurseUser,
	deleteSavedShift,
	deleteSkills,
	deleteTimesheetComponent,
	deleteUserJobHistory,
	deleteUserRecord,
	deleteUserRequirement,
	dismissNurseRatingQuestions,
	dismissOrgRatingQuestions,
	downloadCSV,
	downloadUserProfile,
	editRequirement,
	editSuspendUser,
	enterpriseSettings,
	fetchLocRequiredFields,
	forgotPassword,
	getAcceptedNApplied,
	getAcceptedShiftApplicant,
	getAccessLevels,
	getAccessLevelScopes,
	getACLSRegulatory,
	getAdminAccessLevels,
	getAdminOrganizations,
	getAdminShiftTimes,
	getAlert,
	getAllRequirements,
	getAppliedShiftApplicant,
	getAuditLogs,
	getAvailableNps,
	getClinicianPools,
	getConnectrnRequirement,
	getCPRRegulatory,
	getDecryptedUserRequirement,
	getDeptRequirement,
	getDnrList,
	getDNRReason,
	getEditUsershiftList,
	getEMRList,
	getFilters,
	getFullShiftHistory,
	getGeoLocation,
	getGlobalFeatures,
	getHolidayDates,
	getIdentificationInfo,
	getIsRedirectToFountain,
	getIsShiftForceFilter,
	getJobHistory,
	getLocationRequirement,
	getLocationSettings,
	getLocationUser,
	getLocById,
	getLocShiftTimes,
	getLoyaltyEventsByNurseId,
	getLoyaltyLevel,
	getLoyaltyRewards,
	getNotCheckinTimesheet,
	getNPSQuestion,
	getNurseRequirements,
	getNurseShiftHistory,
	getOldRequests,
	getOnboardingStatus,
	getOrgAcquisition,
	getOrganizationMessages,
	getOrgById,
	getOrgFeatures,
	getOrgRequirements,
	getOrgSettings,
	getOrgShiftTimes,
	getOrgStatusTypes,
	getPendingRequests,
	getPublicAppliedShiftApplicant,
	getPublicDNRReason,
	getPublicShiftDetail,
	getQRLink,
	getRateIncreaseOptions,
	getRatingQuestions,
	getRegistrationRegulatory,
	getRegulatoryInfo,
	getRequirement,
	getRequirementById,
	getRequirementByIdAndOrg,
	getRequirementByIdToSchedule,
	getSavedFilter,
	getSavedShifts,
	getScopes,
	getShiftDetail,
	getShiftRequirements,
	getShiftsWithPaging,
	getSkills,
	getStates,
	getStatusHistory,
	getSuperPrefForOrganization,
	getSupervisorShiftDetail,
	getSupervisorTimesheetDetail,
	getSupervisorTimesheetsWithPaging,
	getTimesheetComponents,
	getTimesheetNotes,
	getTimesheetsWithPaging,
	getTimezones,
	getUserByFeatureId,
	getUserByFeatureIdWithEmail,
	getUserDefaultPreferences,
	getUserFeatures,
	getUserInfoById,
	getUserJobHistories,
	getUserPreferences,
	getUserRequirements,
	getUserRequirementsForShift,
	getUserRequirementToAdd,
	getUserRequirementToUpdate,
	getUsersWithPaging,
	imgbaseURL,
	init,
	login,
	markAllAsPaid,
	markAsIneligible,
	markAsPaid,
	newUpdatePassword,
	noticeCount,
	notices,
	nurseCheckout,
	nurseDashboard,
	nurseShiftCheckIn,
	nurseShiftTimesheet,
	nurseSkills,
	openShifts,
	organization,
	organizationById,
	processTimesheets,
	publicCheckBackToBack,
	publicRejectShiftApplicantWithReason,
	publicUndoRejectShiftApplicant,
	redirectURL,
	rejectShiftApplicant,
	rejectShiftApplicantWithReason,
	rejectUser,
	removeOrgUser,
	removePositionFromShift,
	removeUserFromOrgByAdmin,
	reportError,
	requestShiftApplicant,
	resetOnboarding,
	roleOptions,
	saveAccessLevel,
	saveEditedTimesheet,
	savefilter,
	saveShiftForLater,
	saveSkills,
	saveSuperPrefForOrganization,
	saveUserPreferences,
	searchAdminAccessLevels,
	searchUserRequirement,
	searchUsers,
	sendMessages,
	setActiveUser,
	setPicture,
	setProfilePic,
	setPush,
	setUserRemediation,
	shiftcalloutexcuse,
	shiftsAvailable,
	skipNurseOnboardingRequirement,
	submitNPS,
	submitNurseRatingQuestions,
	supervisorCancelShift,
	supervisorDashboard,
	supervisorDashboardDay,
	supervisorDashboardV2,
	supervisorReportNoShowApplicant,
	supervisors,
	supervisorShiftSearch,
	supervisorShiftsForQuickActions,
	supervisorTimesheetCheckout,
	suspendUser,
	token,
	unassignReqToDept,
	unassignReqToLoc,
	unassignReqToOrganization,
	undoRejectShiftApplicant,
	unSuspendUser,
	updateAccessLevel,
	updateAccessLevelScopes,
	updateAclsCertificateInfo,
	updateAdminShiftTime,
	updateAssignReqToOrganization,
	updateBackfillShiftFeature,
	updateComponent,
	updateCprCertificateInfo,
	UpdateDeptName,
	updateFeatureStatus,
	updateIdentificationInfo,
	updateIncetivePermissions,
	updateJobHistoryByNurse,
	updateLocationDetails,
	updateLocationSettings,
	updateNurseDetails,
	updateNurseFeatureByName,
	updateNurseRequirement,
	updateOrgSettings,
	updateRateIncrease,
	updateRegistrationInfo,
	updateReqWithFieldsToLoc,
	updateSecurityCode,
	updateSecurityCodeByAdmin,
	updateShift,
	updateshiftcalloutexcuse,
	updateShiftFeature,
	updateShiftFeatureByName,
	updateShiftVisibility,
	updateSkills,
	updateSupervisorDetails,
	updateTestUser,
	updateTimesheetStatus,
	updateTimesheetStatusAndTime,
	updateUserBeatAdmin,
	updateUserContact,
	updateUserFeature,
	updateUserHazardPay,
	updateUserInfo,
	updateUserJobHistory,
	updateUserJobHistoryByAdmin,
	updateUserOrgByAdmin,
	updateUserRequirement,
	updateUserRole,
	updateUserSkill,
	updateUserSpeciality,
	updateUserSTATCashStatus,
	updateUserYearsOfExperience,
	uploadFileOnS3,
	uploadFileOnS3UserProfile,
	uploadResume,
	userContact,
	userinfo,
	userJobHistory,
	userSkill,
	withdrawShift,
	yearOfExpOptions
};

export default Agent;
